import React from 'react';

const CheckHasData = ({value, colorText = "#898989"}) => {
    if (value) return <span>{value}</span>

    return (<span className={`italic text-[${colorText}]`}>Sem informações</span>)
};

export default CheckHasData;